"use client"

import type React from "react"

import { useState } from "react"

interface SettingsToggleProps {
  id: string
  defaultChecked?: boolean
  onChange?: (checked: boolean) => void
}

export function SettingsToggle({ id, defaultChecked = false, onChange }: SettingsToggleProps) {
  const [checked, setChecked] = useState(defaultChecked)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked)
    onChange?.(e.target.checked)
  }

  return (
    <div className="relative inline-block w-12 h-6 align-middle select-none transition duration-200 ease-in">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
        className="absolute block w-6 h-6 rounded-full bg-white border-2 border-slate-300 appearance-none cursor-pointer transition-all"
        style={{
          right: checked ? "0" : "auto",
          borderColor: checked ? "#4F46E5" : "#cbd5e1",
        }}
      />
      <label
        htmlFor={id}
        className="block overflow-hidden h-6 rounded-full bg-slate-300 cursor-pointer transition-colors"
        style={{
          backgroundColor: checked ? "#4F46E5" : "#cbd5e1",
        }}
      />
    </div>
  )
}
